import { Toast } from '@10d/tend-ui/primitives';

import { Method } from './types';

import { requestWithCheckVersion, RequestWithCheckVersionProps } from './requestWithCheckVersion';

// TODO: Fix this type, remove any
export interface ObjectWithAnyKeys {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

interface RequestProps extends RequestWithCheckVersionProps {
  withoutLoginRedirect?: boolean;
}

const request = (
  method: Method,
  url: string,
  { withoutLoginRedirect, ...options }: RequestProps = {},
) => {
  const { showError = true, ...params } = options?.params || {};

  return requestWithCheckVersion(method, url, { ...options, params })
    .then(({ data }) => data || {})
    .catch(err => {
      const { status, data } = err.response ?? {};

      if (status === 403) {
        if (!withoutLoginRedirect) {
          window.location.replace(`/accounts/login/samolet/?next=${window.location.pathname}`);
        }

        throw err;
      }

      if (showError) {
        status === 400
          ? data.type === 'invalid' &&
            Toast.error({
              message: 'Ошибка',
              description: String(data.payload),
            })
          : status &&
            Toast.error({
              message: 'Ошибка',
              description: `Произошла ошибка при обращении к серверу: ${status}`,
            });
      }

      throw err;
    });
};

export const get = (url: string, params?: RequestProps['params'], config?: RequestProps) =>
  request('get', url, {
    ...config,
    params: params ? clearEmptyParams(params) : undefined,
  });

export const post = (url: string, data?: RequestProps['data'], config?: RequestProps) =>
  request('post', url, { ...config, data });

export const put = (url: string, data?: RequestProps['data'], config?: RequestProps) =>
  request('put', url, { ...config, data });

export const patch = (url: string, data?: RequestProps['data'], config?: RequestProps) =>
  request('patch', url, { ...config, data });

export const del = (url: string, data?: RequestProps['data'], config?: RequestProps) =>
  request('delete', url, { ...config, data });

export default request;
